import { api } from "@/api"

type SendTransactionReceiptRequest = {
  email?: string
  sms?: string
}

export const sendTransactionReceipt = async (
  transactionId: string,
  params: SendTransactionReceiptRequest
) => {
  await api.post(
    `/transactions/${transactionId}/send-receipt/`,
    {
      body: params,
    }
  )
}
